var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_vm._m(0)])
}
var staticRenderFns = [function (_c,_vm){return _c('p',[_c('span',[_vm._v("Copyright ©")]),_vm._v(" Sound Republica, Inc., All Rights Reserved. ")])
}]

export { render, staticRenderFns }